import axios from 'axios'
import store from '@/store'
import router from '@/router'
import { Toast } from 'vant'
import { forceGetAuth } from '@lyh/jslogin'
import { getToken } from '@/assets/js/account'

/* eslint-disable */
let baseUrl = process.env.VUE_APP_BASE_URL
let ossBaseUrl = process.env.VUE_APP_OSS_URL
let FTURL = process.env.VUE_APP_FTURL
let JSONURL = process.env.VUE_APP_JSON

// 当配置了xhr.withCredentials = true时，必须在后端增加 response 头信息Access-Control-Allow-Origin，且必须指定域名，而不能指定为*
axios.defaults.withCredentials = true
axios.defaults.timeout = 15000

// 请求拦截
axios.interceptors.request.use(
  function (config) {
    //图片上传特定headers
    let token = sessionStorage.getItem('LYH_TOKEN') ?? ''
    if (token) config.headers.Authorization = 'JWT ' + token

    let sou = sessionStorage.getItem('LYH_JSLOGIN_SOURCE') ?? ''
    switch (sou) {
      case '1':
        config.headers.platformType = 3
        break

      case '2':
        config.headers.platformType = 0
        break
      
      case '999':
        config.headers.platformType = 0
        break

      case '1000':
        config.headers.platformType = 2
        break
    }

    return config
  },
  function (error) {
    console.log(error)
    return false
  }
)

// 响应拦截
axios.interceptors.response.use(
  function (response) {
    Toast.clear()
    if (response.data) {
      if (
        response.config.url.indexOf('https://rs-os-lyh-kypt-publicread-text-bosmetadata-test.yanzhiquan.net') > -1 ||
        response.config.url.indexOf('https://rs-os-lyh-kypt-publicread-text-bosmetadata-prod.yanzhiquan.net') > -1 ||
        response.config.url.indexOf('https://rs-os-lyh-kypt-publicread-text-bosmetadata-preprod.yanzhiquan.net') > -1
      ) {
        return response.data
      }
      if (response.config.isJson) {
        return response.data
      }
      if (response.data.success) {
        let result = response.data.result
        if (!response.data.result) {
          result = true
        }
        return result
      } else {
        // console.log(response.data, '错误信息')
        if (response.data.errCode == 'A0230') {
          sessionStorage.clear()
          router.go(0)
        }
        if (response.config.url.indexOf('ft.liangyihui.net') > -1) {
          return response.data
        }
        Toast({
          message: response.data.userTips,
          duration: 2500
        })
        return false
      }
    } else {
      return false
    }
  },
  async function (error) {
    if (error.response.data.errCode == 'A0230') {
      sessionStorage.clear()
      // router.go(0)
      // window.location.reload()
      const res = await forceGetAuth({ loginStyle: 2, canClose: true })

      sessionStorage.setItem('LYH_JSLOGIN_AUTH_KEY', res)
      await getToken()
      return new Promise((resolve, reject) => {
        try {
          resolve(axios(error.config))
        } catch (err) {
          reject(err)
        }
      })
    }
    console.log(error, error.response)
    Toast.clear()
    Toast({
      message: '服务器开小差啦～',
      duration: 2500
    })

    console.log('响应拦截报错')
    return false
  }
)

export { axios, baseUrl, ossBaseUrl, FTURL, JSONURL }
